import React, { useEffect, useState } from "react";
import { getProvider } from "../shared/data";

function isFunction(functionToCheck) {
    return functionToCheck && {}.toString.call(functionToCheck) === "[object Function]";
}

const Options = (props) => {
    return props.options.map((opt, index) => {
        return (
            <option key={`select${props.name}${opt.value}_${index}`} value={opt.value}>
                {opt.text}
            </option>
        );
    });
};

const OptionGroup = (props) => {
    return (
        <optgroup label={props.label}>
            <Options name={props.name} options={props.options} />
        </optgroup>
    );
};

export const Picklist = (props) => {
    const [state, setState] = useState({
        value: props.value || props.defaultValue,
        options: props.options || [],
    });

    useEffect(() => {
        loadOptions();
    }, []);

    useEffect(() => {
        if (props.options) {
            this.loadOptions();
        }
    }, [props.options]);

    useEffect(() => {
        const value = props.value || props.defaultValue || "";

        setState({
            options: state.options,
            value: props.defaultValue,
        });

        if (value) {
            if (props.onValidatePair) {
                props.onValidatePair(value);
            }
        }
    }, [props.defaultValue, state.options, props.value]);

    const loadOptions = async () => {
        const options = props.provider ? await getProvider(props.provider) : props.loadOptions ? await props.loadOptions() : props.options || [];

        // Catch for success or failure
        if (options.success || options.error) {
            return;
        }

        setState({
            ...state,
            options,
        });
    };

    const updateField = (e) => {
        const value = e.currentTarget.value;
        const fullValue = state.options.find((o) => o.value.toString() === value.toString()) || "";

        const name = e.currentTarget.name;

        if (props.onValidatePair) {
            props.onValidatePair(e.target.value);
        }

        if (props.updateOnChange && isFunction(props.updateOnChange)) {
            props.updateOnChange(name, fullValue);
        }
    };

    const fullOptions = props.excludeSelect ? state.options : [{ text: "-- Select --", value: "" }, ...state.options];
    const groupOptions = props.groups;
    const value = state.value && state.value.hasOwnProperty("value") ? state.value.value : "";

    const groups = groupOptions ? (
        groupOptions.length > 1 ? (
            groupOptions.map((group, index) => {
                return <OptionGroup key={`selectGroup_${index}`} name={props.name} options={group.options} label={group.label} />;
            })
        ) : (
            <Options name={props.name} options={groupOptions[0].options} />
        )
    ) : null;

    return (
        <select
            id={props.name}
            name={props.name}
            disabled={props.disabled}
            hidden={props.invisible}
            multiple={props.multiple}
            required={props.required}
            size={props.size}
            value={value}
            onChange={updateField}
            onBlur={props.onBlur}
        >
            <Options name={props.name} options={fullOptions} />
            {groups}
        </select>
    );
};

Picklist.defaultProps = {
    defaultValue: "",
};
